import banner from "./banner.jpeg"
import logo from "./logo.jpg"

const shop = {
    id: "shop021",
  
    vendorId: "rv2KnpChiHSpXQkrTFnhst1omw42",
  
    slug: "coldest-water-ph",
  
    name: "The Coldest Water",
  
    category: "grocery",
  
    rating: 4.5,
  
    deliveryTime: "20-30 mins",
  
    featured: true,
  
    logo: logo,
  
    banner: banner,

    size: "small",

    products: [],

    location: "Port Harcourt",

    deliveryPricing: {
      baseFee: 500,
      perKm: 180
    },

    location2: {
      area: "Wuse 2",
      city: "Abuja",
    
      coordinates: {
        lat: 9.0765,
        lng: 7.3986
      }
    },
   
  };
  
  export default shop;